<template>
  <b-container>
    <h1 class="title text-center">Manage Cards</h1>

    <div
      v-if="isLoading"
      class="loader"
    >
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>

    <b-row v-else>
      <b-card class="col-md-12">
        <b-row class="mt-4">
          <div class="col-md-6">
            <div class="d-inline-flex w-100 justify-content-between p-0">
              <h5 class="mt-2">Cards:</h5>
              <button type="button" class="btn btn-light btn-sm border mb-2" @click="showCardElement">Add Card</button>
            </div>

            <table
              v-if="cards.length > 0"
              class="table font-lighter table-hover"
            >
              <thead>
                <th>#</th>
                <th>Card Number</th>
                <th>Expiry Date</th>
                <th class="text-center">Action</th>
              </thead>

              <tbody>
                <tr v-for="(card, index) in cards">
                  <td>{{ index + 1 }}</td>
                  <td>**** **** **** {{ card.attributes.last4 }}</td>
                  <td>{{ card.attributes.exp_month }}/{{ card.attributes.exp_year }}</td>
                  <td class="text-center">
                    <b-link class="text-danger" @click="removeCard(card.id, index)">
                      <font-awesome-icon icon="times" />
                    </b-link>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-else
              class="border-top pt-2"
            >
              <p>No card.</p>
            </div>
          </div>

          <div class="col-md-6" v-show="addCard">
            <form method="post" id="payment-form">
              <div class="form-row">
                <label for="card-element">Credit or debit card</label>
                <div id="card-element" class="mt-2" style="width: 30em;"></div>
                <div id="card-errors" role="alert"></div>
              </div>

              <div class="text-center mt-4">
                <b-button type="button" variant="outline-primary" @click="createStripeToken">
                  Save Card
                  <b-spinner v-if="isCardCreated" class="ml-2 mt-1" style="height: 20px; width: 20px;"></b-spinner>
                </b-button>
              </div>
            </form>
          </div>
        </b-row>
      </b-card>
    </b-row>
  </b-container>
</template>

<script>
import { getCards, createCard, destroyCard } from '../store/api'
var stripe = Stripe(process.env.VUE_APP_STRIPE_PK)

export default {
  name: "card",

  data() {
    return {
      cards: [],
      isLoading: true,
      isCardCreated: false,
      addCard: false,
      card: '',
    }
  },

  created() {
    getCards()
      .then(response => {
        this.cards = response.data
        this.isLoading = false
      })
      .catch(erorr => {
        this.isLoading = false
        this.$notify({
          type: 'error',
          text: "Something went wrong. Please try again by refreshing page."
        })
      })
  },

  methods: {
    showCardElement() {
      if (this.addCard)
        this.addCard = false
      else {
        this.addCard = true
        this.card = stripe.elements().create('card', {
          style: {
            base: {
              fontSize: '16px',
            },
          },
          hidePostalCode: true
        })
        this.card.mount('#card-element')
      }
    },
    createStripeToken() {
      this.isCardCreated = true
      stripe.createToken(this.card)
        .then(result => {
          if (result.error){
            this.isCardCreated = false
            document.getElementById('card-errors').textContent = result.error.message
          } else {
            document.getElementById('card-errors').textContent = ''
            createCard({ token: result.token.id })
              .then(response => {
                this.cards = response.data
                this.isCardCreated = false
                this.addCard = false
                this.$notify({
                  type: 'success',
                  text: 'Your card is saved successfully.'
                })
              })
              .catch(error => {
                this.isCardCreated = false
                this.$notify({
                  type: 'error',
                  text: 'Something went wrong! Please try again.'
                })
              })
          }
        })
    },
    removeCard(card_id, index) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      })
        .then((result) => {
          if (result.value) {
            destroyCard(card_id)
              .then(response => {
                this.$swal('Removed!', 'Your card has been removed successfully.', 'success')
                this.cards.splice(index, index)
              })
              .catch(error => {
                this.$notify({
                  type: 'error',
                  text: 'You\'re unable to delete this address'
                })
              })
          }
        })
    },
  },

  beforeCreate: function() {
    document.body.className = '';
  },
}
</script>

<style scoped>
  .btn-outline-primary {
    color: #5663FF;
    border-color: #5663FF;
    background-color: white;
    box-shadow: none;
  }
  .btn-outline-primary:hover {
    color: white;
    border-color: #5663FF;
    background-color: #5663FF;
  }
  #card-errors {
    color: #D9534F;
    padding-top: 5px;
    padding-left: 2px;
  }
</style>
